"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var ContentLine_1 = require("../contentLine/ContentLine");
var userDetailsStyles_1 = require("./userDetailsStyles");
var Translation_1 = require("../../../common/components/presentation/Translation/Translation");
var TextTooltip_1 = require("../common/TextTooltip/TextTooltip");
var UserPaymentDetails_1 = require("./UserPaymentDetails");
var UserDetails = function (_a) {
    var firstname = _a.firstname, lastname = _a.lastname, email = _a.email, telephone = _a.telephone, reservationContact = _a.reservationContact, transactionDetails = _a.transactionDetails;
    var style = userDetailsStyles_1.default();
    var emailComponent = function () { return (<core_1.Typography variant="subtitle1" noWrap={true}>
      {email}
    </core_1.Typography>); };
    return (<core_1.Box data-test="summary:container:user_details" className={style.userDetailsWrapper}>
      <ContentLine_1.default mainContent={<core_1.Typography variant="subtitle1" className={style.title}>
            <Translation_1.default id="myDetails.header"/>
          </core_1.Typography>} dataTest={"summary:user_details:title"}/>
      <ContentLine_1.default mainContent={<core_1.Typography variant="subtitle1">
            <Translation_1.default id="myDetails.label.firstname"/>
          </core_1.Typography>} secondaryContent={<core_1.Typography className={style.userFirstName} variant="subtitle1">
            {firstname}
          </core_1.Typography>} dataTest={"summary:user_details:firstname"}/>
      <ContentLine_1.default mainContent={<core_1.Typography variant="subtitle1">
            <Translation_1.default id="myDetails.label.lastname"/>
          </core_1.Typography>} secondaryContent={<core_1.Typography className={style.userLastName} variant="subtitle1">
            {lastname}
          </core_1.Typography>} dataTest={"summary:user_details:lastname"}/>
      <ContentLine_1.default mainContent={<core_1.Typography variant="subtitle1">
            <Translation_1.default id="myDetails.label.email"/>
          </core_1.Typography>} secondaryContent={<TextTooltip_1.default text={email} content={emailComponent()}/>} dataTest={"summary:user_details:email"}/>
      <ContentLine_1.default mainContent={<core_1.Typography variant="subtitle1">
            <Translation_1.default id="myDetails.label.telephone"/>
          </core_1.Typography>} secondaryContent={<core_1.Typography variant="subtitle1">{telephone}</core_1.Typography>} dataTest={"summary:user_details:telephone"}/>
      {reservationContact && (<ContentLine_1.default mainContent={<core_1.Typography variant="subtitle1">
              <Translation_1.default id="myDetails.label.reservationContact"/>
            </core_1.Typography>} secondaryContent={<core_1.Typography variant="subtitle1">{reservationContact}</core_1.Typography>} dataTest={"summary:user_details:reservationContact"}/>)}
      {transactionDetails && <UserPaymentDetails_1.default transactionDetails={transactionDetails}/>}
    </core_1.Box>);
};
exports.default = UserDetails;
